import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskItineraryPrintInfoCtrl implements IController {

  task: TaskModel;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskItineraryPrintInfo', {
    bindings: {
      task: '<'
    },
    template: require('./task-itinerary-print-info.html').default,
    controller: taskItineraryPrintInfoCtrl
  });
